function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 0s256 41.716 512 41.716S1024 0 1024 0v43H0V0z"
});

var SvgHappyLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1024 43"
}, props), _ref);

export default SvgHappyLine;